import request from "@/utils/request";

export type ReviewStatus = 1 | 2 | 3;
export type ReviewStatusParam = "1" | "2" | "3";
export type ReviewViewScope = "1" | "2";
export type ReviewIdentifier = number | string;

export interface ListReviewParams {
  startTime?: string;
  endTime?: string;
  status?: ReviewStatusParam;
  applyType?: string;
  adminId?: string;
  page?: string;
  size?: string;
  viewScope: ReviewViewScope;
}

export interface ReviewItem {
  /** 管理员id */
  adminId?: number;
  adminName?: string;
  /** 变更后 */
  after?: string;
  /** 申请类型 */
  applyType?: number;
  /** 关联对象 */
  associatedObject?: string;
  /** 变更前 */
  before?: string;
  /** 提交时间 */
  createdAt?: number;
  /** 处理人 */
  handlerName?: string;
  /** 工单 */
  id?: number;
  /** 处理时间 */
  processingTime?: number | string;
  /** 审核意见 */
  reviewComments?: string;
  /** 状态：1待审核 2已通过 3已拒绝 */
  status?: number;
  /** 更新时间 */
  updatedAt?: number;
  [property: string]: any;
}

export interface ListReviewResponse {
  list: ReviewItem[];
  totalCount: number;
  pendingCount?: number;
}

export interface ReviewApplyTypeItem {
  id?: ReviewIdentifier;
  applyType?: ReviewIdentifier | null;
  type?: ReviewIdentifier | null;
  name?: string | null;
  [property: string]: unknown;
}

export interface ListApplyTypeResponse {
  list: ReviewApplyTypeItem[];
}

export interface ReviewApplicantItem {
  adminId?: number;
  id?: number;
  applyType?: number;
  associatedObject?: string;
  before?: string;
  after?: string;
  status?: number;
  reviewComments?: string;
  handler?: number;
  processingTime?: number;
  createdAt?: number;
  updatedAt?: number;
  adminName?: string;
  handlerName?: string;
  [property: string]: unknown;
}

export interface ListReviewApplicantResponse {
  list: ReviewApplicantItem[];
}

export interface ApproveReviewParams {
  id: number;
  reviewComments: string;
  [property: string]: any;
}

export interface RejectReviewParams {
  id: number;
  reviewComments: string;
  [property: string]: any;
}

/** 获取审核列表 GET /api/v1/sys/listReview */
export async function listReview(params: ListReviewParams) {
  return request<ListReviewResponse>("/api/v1/sys/listReview", {
    method: "GET",
    params,
  });
}

/** 获取审核类型列表 GET /api/v1/sys/listApplyType */
export async function listApplyType() {
  return request<ListApplyTypeResponse>("/api/v1/sys/listApplyType", {
    method: "GET",
  });
}

/** 获取审核申请人列表 GET /api/v1/sys/listReviewApplicant */
export async function listReviewApplicant() {
  return request<ListReviewApplicantResponse>(
    "/api/v1/sys/listReviewApplicant",
    {
      method: "GET",
    },
  );
}

/** 审核通过 POST /api/v1/sys/approveReview */
export async function approveReview(data: ApproveReviewParams) {
  return request<unknown>("/api/v1/sys/approveReview", {
    method: "POST",
    data,
  });
}

/** 拒绝审核 POST /api/v1/sys/rejectReview */
export async function rejectReview(data: RejectReviewParams) {
  return request<unknown>("/api/v1/sys/rejectReview", {
    method: "POST",
    data,
  });
}
